import { withFiltersContext } from '@contexts/Filters';

import DestinationFilters from './component';

export default withFiltersContext(DestinationFilters);
